// import React, { useState } from 'react';
// import { lazy } from 'react';
// import { useTranslation } from 'react-i18next';

// const Routes = () => {
//     const { t, i18n } = useTranslation();
// };

//eslint-disable-next-line import/no-anonymous-default-export
export default {
    home: '/',
    aboutUs: '/about-us',
    tirParking: '/tir-parking',
    carService: '/car-service',
    hostel: '/hostel',
    contacts: '/contacts',
};
